import {Modalator} from 'hegyd/core/resources/assets/js/utils/Modalator.js'

export default class ModalInformationExtranetContainer extends HTMLDivElement {

    constructor() {
        super();
        this.elements = this.querySelectorAll('.modal');
        this.container = this.querySelector(".modal-backdrop");
    }

    connectedCallback() {
        this.initModalsManagement();
    }

    initModalsManagement() {

        if (this.elements.length) {
            this.initModal(this.elements[0]);
        }
    }
    
    initModal(modal) {
        var id = modal.id;
        var urlShow = modal.dataset.showurl;
        var selector = '#' + id;
        var modalator = new Modalator();
        var self = this;

        $(selector).on('hide.bs.modal', function(event) { // modelId is dynamic
            self.displayNextModal();
        });

        modalator.initRemoteModal(selector, urlShow,
            e => {},
            data => {
                $(selector).modal('hide');
            } );
    }

    displayNextModal(){
        if (this.elements.length) {
            this.elements[0].parentNode.removeChild(this.elements[0]);
        }
        this.elements = this.querySelectorAll('.modal');
        if (this.elements.length) {
            this.initModal(this.elements[0]);
        }
    }
}

customElements.define('modal-information-container', ModalInformationExtranetContainer,{extends: 'div'});
